import { UniversityStudyRoomTemplate } from "@/components/UniversityStudyRoomTemplate";

const UofTScarborough = () => {
  return (
    <UniversityStudyRoomTemplate
      universityName="University of Toronto – Scarborough (UTSC)"
      universityShortName="UTSC"
      slug="university-of-toronto-scarborough"
      seoTitle="UTSC Study Rooms | University of Toronto Scarborough Study Guide"
      seoDescription="Complete guide to study rooms at UTSC. Find library quiet zones, Highland Hall study spaces, and silent study rooms. Plus free 24/7 online alternative."
      seoKeywords="utsc study rooms, university of toronto scarborough library, utsc library, highland hall, utsc study spaces, scarborough campus study"
      canonicalUrl="/study-room/university-of-toronto-scarborough/"
      heroDescription="A comprehensive guide to study rooms and spaces at U of T Scarborough, including the UTSC Library and Highland Hall."
      libraryWebsiteUrl="https://utsc.library.utoronto.ca/"
      libraryWebsiteName="UTSC Library"
      studySpaces={[
        {
          name: "UTSC Library - First Floor",
          features: "Offers computers and group study rooms for collaborative work.",
          feedback: "Students appreciate having dedicated group rooms but sometimes find the first-floor environment noisy."
        },
        {
          name: "UTSC Library - Second Floor",
          features: "Contains quiet and silent study rooms for focused individual work.",
          feedback: "Highly rated for having distinct levels of quiet; great for concentrated study sessions."
        },
        {
          name: "Highland Hall",
          features: "Five-storey multi-purpose building with faculty offices, lecture halls and a variety of study nooks. There are both busy zones and silent corners.",
          feedback: "Because the hall is a central hub, it can be crowded and noisy, though silent sections exist."
        },
        {
          name: "Student Centre",
          features: "Food court and lounge area often used as study space.",
          feedback: "Feels like a canteen; constant chatter makes studying difficult unless you go very early or late."
        }
      ]}
      guideContent={
        <>
          <p className="mb-4">
            UTSC students seeking true silence should head straight to the <strong>second floor of the campus library</strong> where dedicated silent rooms enforce quiet.
          </p>
          <p className="mb-4">
            For collaborative projects, the <strong>first-floor group rooms</strong> provide computers and screens, but expect ambient noise. <strong>Highland Hall</strong> is UTSC's new architectural showpiece; its open staircases and hidden alcoves mean you can alternate between lively common areas and secluded study nooks.
          </p>
          <p>
            Avoid the <strong>Student Centre</strong> if you need to focus—its food-court vibe may suit group brainstorming but not intense concentration. On nice days, consider studying outside the hall where natural light and fresh air can help you recharge.
          </p>
        </>
      }
      summaryTips={[
        "Go to the second floor for silence: The UTSC Library's second floor has dedicated silent study rooms where quiet is enforced.",
        "Explore Highland Hall's hidden corners: The building has quiet alcoves tucked away from the busy main areas.",
        "Avoid the Student Centre for focus work: The food court atmosphere makes it difficult to concentrate.",
        "Arrive early during exams: Study spaces fill up quickly during midterms and finals week.",
        "Try CSW for guaranteed quiet: Virtual study rooms offer a distraction-free environment when campus is too loud."
      ]}
    />
  );
};

export default UofTScarborough;
